export default class UserProfile {
  constructor(props = {}) {
    var _props$firstName, _props$lastName, _props$email, _props$fullName, _props$name;
    this.firstName = (_props$firstName = props.firstName) !== null && _props$firstName !== void 0 ? _props$firstName : '';
    this.lastName = (_props$lastName = props.lastName) !== null && _props$lastName !== void 0 ? _props$lastName : '';
    this.email = (_props$email = props.email) !== null && _props$email !== void 0 ? _props$email : '';
    this.fullName = (_props$fullName = props.fullName) !== null && _props$fullName !== void 0 ? _props$fullName : '';
    this.name = (_props$name = props.name) !== null && _props$name !== void 0 ? _props$name : '';
    this.userId = props.userId !== undefined ? props.userId : null;
  }
  static from(json) {
    if (!json) return new UserProfile();
    return new UserProfile(json);
  }
  static fromUser(json) {
    return new UserProfile(Object.assign({
      firstName: json.first_name,
      lastName: json.last_name,
      userId: json.user_id
    }, json));
  }
}